import { Component } from '@angular/core';

@Component({
  selector: 'app-gateway',
  templateUrl: './gateway.component.html',
  styleUrls: ['./gateway.component.css']
})
export class GatewayComponent {
  english:boolean=false;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');

  
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }
    else{
      this.english = true;
      this.hindi = false;
    }

  }
}
